import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/api/client";

const AuthContext = createContext(null);

const SESSION_FLAG = "apps2go.session_active";
const SESSION_USER = "apps2go.session_user_email";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");

      // Pakotettu uloskirjautuminen, jos:
      //  - kyseessä on sivun reload (F5/refresh)
      //  - tai sessionStorage on tyhjä (uusi tab tai aiempi tab suljettu)
      const navType =
        typeof performance !== "undefined"
          ? (performance.getEntriesByType?.("navigation")?.[0]?.type)
          : null;
      const isReload = navType === "reload";
      const sessionFlag = sessionStorage.getItem(SESSION_FLAG);

      if (isReload || !sessionFlag) {
        try {
          await api.post("/auth/logout");
        } catch {
          /* ignore */
        }
        sessionStorage.removeItem(SESSION_FLAG);
        sessionStorage.removeItem(SESSION_USER);
        setUser(false);
        setLoading(false);
        return null;
      }
      setUser(data);
      return data;
    } catch {
      sessionStorage.removeItem(SESSION_FLAG);
      sessionStorage.removeItem(SESSION_USER);
      setUser(false);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const beginLogin = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return data;
  };

  const completeLogin = (userPayload) => {
    sessionStorage.setItem(SESSION_FLAG, "1");
    if (userPayload?.email) sessionStorage.setItem(SESSION_USER, userPayload.email);
    setUser(userPayload);
    return userPayload;
  };

  const login = beginLogin;

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    sessionStorage.removeItem(SESSION_FLAG);
    sessionStorage.removeItem(SESSION_USER);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, beginLogin, completeLogin, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

/** Avain käyttäjäkohtaiselle draft-tallennukselle. */
export function draftKey(email, name) {
  return `apps2go.draft.${(email || "guest").toLowerCase()}.${name}`;
}
